export const search = {
  Songs: 'Chansons',
  Playlists: 'Listes de lecture',
  'Top Result': 'Meilleur résultat',
  'No results': 'Aucun résultat',
  'No results where found for': 'Aucun résultat trouvé pour',
};
